/* eslint-disable dot-notation */
import { Button, createStyles, IconButton, makeStyles, Menu, MenuItem, Typography } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Action } from "components/TableCatalog/Table/MenuActions";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { handleAbilityFields } from "domains/Request/component/shared/utils";
import Can from "domains/shared/Can";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    buttonActived: {
      fontSize: 10,
      height: 30,
      marginTop: 15,
      backgroundColor: COLORS.accent,
    },
    buttonDisabled: {
      fontSize: 10,
      height: 30,
      marginBottom: 10,
      marginRight: 10,
      marginTop: 15,
      backgroundColor: COLORS.accent,
      color: "#fff"
    },
    buttonMenu: {
      width: 80,
      height: 29,
      backgroundColor: "#F2994A",
      color: "#fff",
      marginRight: 10,
    },
  })
);
const ITEM_HEIGHT = 40;
interface MenuItemProps<RowData> {
  row?: RowData;
  actions: Action[];
  onRowMenuClick?(key: string, row: any): void;
  menuButton?: boolean;
  isActiveButton?: boolean;
}
export const MenuActions = <RowData, RowDataKey extends keyof RowData>({
  onRowMenuClick,
  row,
  actions,
  menuButton,
  isActiveButton,
}: MenuItemProps<RowData>) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { text } = useText();
  const classes = useStyles();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: any) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };

  const onClick = (event: any, key: string) => {
    event.stopPropagation();
    onRowMenuClick(key, row);
    handleClose();
  };

  const onClickIcon = (event: any) => {
    handleClick(event);
    event.stopPropagation();
  };

    const canFetchItem = (row: any, abilityFields: Record<string, any>) => {
      if (!abilityFields) return true;
      return abilityFields && handleAbilityFields(row, abilityFields);
    };

  return (
    <>
      {menuButton ? (
        <Button
          onClick={onClickIcon}
          className={isActiveButton ? classes.buttonActived : classes.buttonDisabled}
          variant={isActiveButton ? "contained" : "outlined"}
        >
          {text.all.action}
        </Button>
      ) : (
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={(event) => {
            handleClick(event);
            event.stopPropagation();
          }}
        >
          <MoreVertIcon />
        </IconButton>
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4,
            marginTop: "2.2rem",
          },
        }}
      >
        {actions?.map((action) => (
          canFetchItem(row, action?.abilityFields) && (
          <MenuItem onClick={(event) => onClick(event, action.key)}>
            <Typography variant={menuButton ? "h6" : "inherit"}>{action.label}</Typography>
          </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
};



